import React from 'react';
import PropTypes from 'prop-types';

/**
 * Returns the color code for a given confirmation rate.
 * - Green (#1cc88a) for rates >= 80%
 * - Orange (#f6c23e) for rates 60-79%
 * - Red (#e74a3b) for rates < 60%
 *
 * @param {number} rate - Confirmation rate (0-100)
 * @returns {string} Hex color code
 */
export const getConfirmationRateColor = (rate) => {
  if (rate >= 80) return '#1cc88a';
  if (rate >= 60) return '#f6c23e';
  return '#e74a3b';
};

const ConfirmationRateBadge = ({ rate }) => {
  const color = getConfirmationRateColor(rate);

  return (
    <span
      className="badge"
      style={{
        backgroundColor: color,
        color: '#fff',
        fontSize: '0.85rem',
        padding: '4px 10px',
        borderRadius: '4px',
      }}
    >
      {rate.toFixed(1)}%
    </span>
  );
};

ConfirmationRateBadge.propTypes = {
  rate: PropTypes.number.isRequired,
};

export default ConfirmationRateBadge;
